module.exports = __webpack_public_path__ + "img/59.10.pH.556c89e4.png";